

import Vue from 'vue'
import App from './App'
import router from './router'
import VueWechatTitle from 'vue-wechat-title'
import clipboard from 'clipboard';
import 'element-ui/lib/theme-chalk/base.css';
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
import preventReClick from './util/preventReClick' 


import {Popup,Cell,Area,Field} from 'vant'
Vue.use(Popup)
Vue.use(Cell)
Vue.use(Area)
Vue.use(Field)


Vue.use(preventReClick)
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import AlertModule from 'vux/src/plugins/alert/module'


Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
Vue.use(AlertModule)
Vue.component(CollapseTransition.name, CollapseTransition);


Vue.use(VueWechatTitle)


Vue.prototype.clipboard = clipboard;
Vue.config.productionTip = false



/* eslint-disable no-new */
new Vue({
el: '#app',
router,
components: { App },
template: '<App/>'
})


Vue.component('remote-script', {

render: function (createElement) {
var self = this;
return createElement('script', {
attrs: {
type: 'text/javascript',
src: this.src
},
on: {
load: function (event) {
self.$emit('load', event);
},
error: function (event) {
self.$emit('error', event);
},
readystatechange: function (event) {
if (this.readyState == 'complete') {
self.$emit('load', event);
}
}
}
});
},

props: {
src: {
type: String,
required: true
}
}
});


// WEBPACK FOOTER //
// ./src/main.js